import { UI } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

import { useRecoilQuery } from '../../../../hooks/useRecoilQuery';
import { useHomeActions } from '../../../../store/home/capture/actions';
import {
  selectedCustomersActivationYearState,
  yearsState,
} from '../../../../store/home/capture/atom';

import { CustomersActivationContent } from './components/CustomersActivationContent';

export namespace CustomersActivationTypes {
  export interface Props {
    isMobile?: boolean;
  }
}

export const CustomersActivation: React.FC<CustomersActivationTypes.Props> = ({ isMobile }) => {
  const { setSelectedCustomersActivationYear } = useHomeActions();
  const { data: yearSelected } = useRecoilQuery(selectedCustomersActivationYearState);
  const { data: years } = useRecoilQuery(yearsState);

  return (
    <UI.PeriodSelectorPanel
      flex={1}
      fullWidth
      title="ATIVAÇÃO DE NOVOS CLIENTES"
      onPeriodChange={setSelectedCustomersActivationYear}
      options={years?.map((year) => ({ label: year, value: year })) || []}
      testId="customers-activation-panel"
      selectedOption={yearSelected || ''}
      titleCustomProps={{ fontSize: Typography['fontsize.lg'] }}
      isMobile={isMobile}>
      <CustomersActivationContent isMobile={isMobile} />
    </UI.PeriodSelectorPanel>
  );
};
